<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-bind:style="{ width: width }" @click.stop>
          <button class="modal-default-button" @click="closeModal" id="modal2">
            X
          </button>
          <div class="modal-header">
            <h3>{{ title }}</h3>
          </div>
          <div class="modal-body">
            <component :is="component" :data="data" v-on:close="closeModal"></component>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import BulkEditTasks from '../Dashboard/Views/Tasks/Modal/BulkEditTasks'
  import ClientRequiresPo from '../Dashboard/Views/Jobs/Modal/ClientRequiresPO'
  import Constants from 'src/utilities/constants'
  import Company from '../Dashboard/Views/Companies/Modal/Company'
  import ConfirmArchiveDeployment from '../Dashboard/Views/Camunda/Modal/ConfirmArchive'
  import ConfirmDelete from '../GeneralViews/Modal/ConfirmDelete'
  import ConfirmTerminate from '../Dashboard/Views/Jobs/Modal/ConfirmTerminate'
  import CreateTaskFolders from '../Dashboard/Views/Files/Modal/CreateTaskFolders'
  import EditTask from '../Dashboard/Views/Tasks/Modal/EditTask'
  import ExportTaskName from '../Dashboard/Views/TaskNames/Modal/ExportTaskName'
  import ExportTaskTemplate from '../Dashboard/Views/TaskTemplates/Modal/ExportTaskTemplate'
  import InformationNotice from '../GeneralViews/Modal/InformationNotice'
  import JobTemplate from '../Dashboard/Views/Jobs/Modal/JobTemplate'
  import NoClientSelected from '../Dashboard/Views/Jobs/Modal/NoClientSelected'
  import NoContactEmail from '../Dashboard/Views/Jobs/Modal/NoContactEmail'
  import NoContactFound from '../Dashboard/Views/Companies/Modal/NoContactFound'
  import NoProjectResultsFound from '../Dashboard/Views/Projects/Modal/NoProjectResultsFound'
  import ModifyTaskDueDates from '../Dashboard/Views/Tasks/Modal/ModifyTaskDueDates'
  import ReinspectionTask from "../Dashboard/Views/Tasks/Modal/ReinspectionTask"
  import SaveSearch from '../GeneralViews/Modal/SaveSearch.vue'
  import TaskField from '../Dashboard/Views/TaskTemplates/Modal/TaskField'
  import UploadForms from '../Dashboard/Views/Files/Modal/UploadForms'
  import VerifyJobStatusChange from '../Dashboard/Views/Jobs/Modal/VerifyJobStatusChange'
  import ViewProject from '../Dashboard/Views/Projects/Modal/ViewProject'
  import ViewJob from '../Dashboard/Views/Jobs/Modal/ViewJob'
  import ViewTask from '../Dashboard/Views/Tasks/Modal/ViewTask'
  import {focusTrap} from '@/utilities/utils'

  export default {
    props: ['title', 'component', 'data', 'width'],
    components: {
      BulkEditTasks,
      ClientRequiresPo,
      Company,
      ConfirmArchiveDeployment,
      ConfirmDelete,
      ConfirmTerminate,
      CreateTaskFolders,
      EditTask,
      ExportTaskName,
      ExportTaskTemplate,
      InformationNotice,
      JobTemplate,
      ModifyTaskDueDates,
      NoClientSelected,
      NoContactEmail,
      NoContactFound,
      NoProjectResultsFound,
      ReinspectionTask,
      SaveSearch,
      TaskField,
      UploadForms,
      VerifyJobStatusChange,
      ViewProject,
      ViewJob,
      ViewTask
    },
    methods: {
      closeModal() {
        this.maybeResetQuerystringParams()
        this.$emit('close')
      },
      // the following querystring params are used in a watcher in ProjectContainer.vue
      // and set by ViewProcessInstance.vue. They need to be reset back to nothing when the Modal is closed
      // so subsequent clicks on user tasks trigger a change in the URL which triggers re-opening the Modal
      // with the selected task
      maybeResetQuerystringParams() {
        let replace = false
        let query = Object.assign({}, this.$route.query)
        if (query.hasOwnProperty('taskId')) {
          delete query.taskId
          replace = true
        }
        if (query.hasOwnProperty('processInstanceId')) {
          delete query.processInstanceId
          replace = true
        }
        if (query.hasOwnProperty('taskNameKey')) {
          delete query.taskNameKey
          replace = true
        }
        if (query.hasOwnProperty('taskTemplateKey')) {
          delete query.taskTemplateKey
          replace = true
        }
        if (replace) {
          this.$router.replace({ query })
        }
      }
    },
    mounted() {
      document.addEventListener('keydown', (e) => {
        if (e.keyCode === Constants.ESCAPE_KEY) {
          this.$emit('close')
        }
      })
      focusTrap('modal2', this.component)
      this.$store.set('modalTracker/modal2', this.component)
    },
    destroyed() {
      this.$store.set('modalTracker/modal2', null)
    },
    watch: {
      'component': {
        handler: function () {
          this.$store.set('modalTracker/modal2', this.component)
        }
      }
    }
  }
</script>
<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 1092;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    z-index: 1093;
  }

  .modal-container {
    width: 74%;
    max-height: calc(100vh - 50px);
    max-width: calc(100vw - 50px);
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    z-index: 999;
  }

  .modal-header, .modal-footer {
    border: none;
    padding: 0;
  }
  .modal-header h3 {
    margin: 0;
    padding: 0;
  }

  .modal-body {
    padding: 0;
    margin: 10px 0;
  }

  .modal-default-button {
    float: right;
    z-index: 100000;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="Modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the Modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>
